import ArrowLeft from './components/ArrowLeft';
import Thumbsup from './components/Thumbsup';

export default {
    ArrowLeft,
    Thumbsup
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/icons/index.ts